import React from "react";
import { Row, Col, Typography, Button } from "antd";

import NotFound from "./notFound.svg";
import { useHistory } from "react-router-dom";
const { Title } = Typography;

export default function NotAllowed() {
  const history = useHistory();

  return (
    <Row justify="center" align="middle" style={{marginTop:'5%'}}> 
      <Col span={8} offset={2}>
        <Row>
          {" "}
          <Title style={{ fontFamily: "Gilroy", fontSize: "2.5em" }}>
            Looks like something is missing...
          </Title>
        </Row>
        <Row>
          <Title level={5} type="secondary">
            You can try refreshing the page again or go back to the previous
            page{" "}
          </Title>
        </Row>
        <Row style={{ marginTop: "2em" }} justify="space-between">
          <Col span={10}>
            <Button
              size="large"
              style={{ background: "#363E3D", color: "white", width: "100%" }}
              onClick={() => history.push("/")}
            >
              Go to home
            </Button>
          </Col>
          <Col span={10}>
            <Button
              size="large"
              style={{
                background: "#F0F8F6",
                color: "#0B7764",
                borderColor: "#0B7764",
                width: "100%",
              }}
              onClick={() => window.location.reload()}
            >
              Refresh
            </Button>
          </Col>
        </Row>
      </Col>
      <Col span={13} offset={1} >
        <img src={NotFound} alt="Not Found" style={{ width: "100%" }} />
      </Col>
    </Row>
  );
}
